"use client";

import React from "react";
import "../animations/animate.css";
import AnimatedBody from "../animations/AnimatedBody.tsx";
import AnimatedTitle from "../animations/AnimatedTitle.tsx";

const Loisirs = () => {
  return (
    <section
      className="relative z-10 w-full items-center justify-center overflow-hidden bg-[#0E1016] bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
      id="loisirs"
    >
      <div className="mx-auto flex w-[90%] flex-col items-center justify-center lg:max-w-[1212.8px]">
        <AnimatedTitle
          text={"Loisirs"}
          className={
            "mb-10 text-left self-start text-[40px] font-bold leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px]"
          }
          wordSpace={"mr-[14px]"}
          charSpace={"mr-[0.001em]"}
        />

        <div className="mx-auto flex w-[100%] flex-col lg:max-w-[1200px] lg:flex-row lg:gap-20">
          <div className="mb-10 flex w-[100%] flex-col gap-4 text-[18px] font-medium leading-relaxed tracking-wide text-[#e4ded7] md:mb-16 md:gap-6 md:text-[20px] md:leading-relaxed lg:mb-16 lg:max-w-[90%] lg:text-[24px]">
            <AnimatedBody
              text="En dehors du développement, j'aime me passionner pour plusieurs activités qui enrichissent ma vie personnelle et ma créativité."
            />

            <AnimatedBody
              delay={0.1}
              text="L'automobile est l'une de mes grandes passions. J'apprécie particulièrement l'ingénierie, le design et l'innovation dans ce domaine. C'est un univers qui allie technologie et esthétique, ce qui résonne avec ma passion pour le développement."
            />

            <AnimatedBody
              delay={0.2}
              text="La photographie est également un de mes loisirs favoris. J'aime capturer des moments, explorer différents angles et compositions, et utiliser la technologie pour créer des images qui racontent une histoire."
            />

            <AnimatedBody
              delay={0.3}
              text="Enfin, les jeux vidéo font partie de mon quotidien. Au-delà du simple divertissement, ils représentent pour moi une source d'inspiration pour le design d'interfaces, l'expérience utilisateur et la narration interactive."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Loisirs;

